module.exports = __webpack_public_path__ + "static/img/template_3.c14da30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/template/template_3.png
// module id = ZNiN
// module chunks = 92